import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import store from './store/store';
import { BrowserRouter } from 'react-router-dom';
import appConfig from './config/app.config';
import { FlagProvider, IConfig } from '@unleash/proxy-client-react';

declare global {
  interface Window {
    Cypress: any;
    store: any;
  }
}

const featureFlagsConfig: IConfig = {
  url: appConfig.FEATURE_FLAGS.PROXY_URL,
  clientKey: appConfig.FEATURE_FLAGS.PROXY_SECRET,
  appName: 'store-admin-frontend',
  refreshInterval: appConfig.FEATURE_FLAGS.REFRESH_RATE
};

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <FlagProvider config={featureFlagsConfig}>
        <Provider store={store}>
          <App />
        </Provider>
      </FlagProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

if (window.Cypress) {
  window.store = store;
}
